import { configureStore } from '@reduxjs/toolkit';

import { clientAPI } from '@api';
import { rootReducer } from '@reducers';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([clientAPI.middleware]),
});
